const flag = (value: unknown): boolean => String(value ?? '').toLowerCase() === 'true';

/** Attendance, leave and salary screens; off until their backend endpoints exist. */
export const HR_EXTRAS_ENABLED = flag(import.meta.env.VITE_FEATURE_HR_EXTRAS);
